module.exports = __webpack_public_path__ + "img/topindicator3.c4a8fbb0.png";